import _styled from "styled-components";
/* eslint-disable jsx-a11y/label-has-associated-control */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import * as styles from "./TextField.styles";
import { getAriaDescribedByForInputField } from "../../../utils/getAriaDescribedByForInputField";
export var TEXT_AREA_INPUT_CLASSNAME = 'text-area__input';
export var TextField = function TextField(props) {
  var $completed = props.$completed,
    className = props.className,
    description = props.description,
    error = props.error,
    feedback = props.feedback,
    id = props.id,
    label = props.label,
    _props$labelHidden = props.labelHidden,
    labelHidden = _props$labelHidden === void 0 ? false : _props$labelHidden,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    required = props.required,
    value = props.value;
  var textareaRef = useRef(null);
  var _useState = useState('auto'),
    _useState2 = _slicedToArray(_useState, 2),
    textAreaHeight = _useState2[0],
    setTextAreaHeight = _useState2[1];
  useEffect(function () {
    if (textareaRef.current) {
      var _getComputedStyle = getComputedStyle(textareaRef.current, null),
        borderBottomWidth = _getComputedStyle.borderBottomWidth,
        borderTopWidth = _getComputedStyle.borderTopWidth;
      var heightAdjustment = parseInt(borderTopWidth, 10) + parseInt(borderBottomWidth, 10);
      setTextAreaHeight("".concat(textareaRef.current.scrollHeight + heightAdjustment, "px"));
    }
  }, [value]);
  var handleChange = function handleChange(e) {
    setTextAreaHeight('auto');
    onChange(e);
  };
  var fieldId = "".concat(id, "-textarea");
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FieldWrapper, {
    $completed: $completed,
    description: description,
    error: error,
    feedback: feedback,
    fieldId: fieldId,
    label: label,
    labelHidden: labelHidden
  }, /*#__PURE__*/React.createElement(_StyledTextarea, _extends({
    "aria-describedby": getAriaDescribedByForInputField({
      fieldId,
      description,
      error
    }),
    "aria-invalid": !!error,
    "aria-label": label,
    "aria-required": required,
    className: TEXT_AREA_INPUT_CLASSNAME,
    onChange: handleChange,
    ref: textareaRef,
    rows: 1,
    style: {
      height: textAreaHeight
    }
  }, props, {
    id: fieldId,
    $_css: styles.textarea
  }))));
};
var _StyledTextarea = /*#__PURE__*/_styled("textarea").withConfig({
  displayName: "TextField___StyledTextarea",
  componentId: "sc-1fm0zu4-0"
})(["", ""], function (p) {
  return p.$_css;
});